import { c as _c } from "react/compiler-runtime";
export const StudentIcon = t0 => {
  const $ = _c(15);
  const {
    selected
  } = t0;
  const strokeColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.643066" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== strokeColor) {
    t3 = <path d="M20.6431 22.0182L30.6431 16.7868L20.6431 11.822L10.6431 16.7868L20.6431 22.0182Z" stroke={strokeColor} strokeWidth="1.55789" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M26.9596 24.8735L20.643 28.178L14.3264 24.8735" stroke={strokeColor} strokeWidth="1.55789" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M14.4116 24.8388L14.4116 19.0814M26.8747 24.8388L26.8747 19.0814" stroke={strokeColor} strokeWidth="1.55789" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M11.6797 23.2014L11.6797 17.444" stroke={strokeColor} strokeWidth="1.55789" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M11.6797 23.6222L11.6797 23.6122" stroke={strokeColor} strokeWidth="2.59648" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = strokeColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};